module.exports = __webpack_public_path__ + "img/lbelc.cdb42926.jpg";